.template {
  display: flex;
  flex-direction: column;
  height: 100%;
}
